/*
 * @Author: Lee
 * @Date: 2019-07-23 11:42:52
 * @LastEditors: Lee
 * @LastEditTime: 2021-12-02 14:24:23
 * @Description: 无
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/client/',
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: {
        scroll: true
      },
      component: resolve => require(['../views/Home.vue'], resolve)
    },
    {
      path: '/product',
      name: 'Product',
      meta: {
        scroll: true
      },
      component: resolve => require(['../views/more_data.vue'], resolve)
    },
    {
      path: '/service',
      name: 'Service',
      meta: {
        scroll: false
      },
      component: resolve => require(['../views/service.vue'], resolve)
    },
    {
      path: '/aboutus',
      name: 'AboutUs',
      meta: {
        scroll: true
      },
      component: resolve => require(['../views/about_us.vue'], resolve)
    },
    {
      path: '/state',
      name: 'State',
      meta: {
        scroll: true
      },
      component: resolve => require(['../views/state.vue'], resolve)
    },
    {
      path: '/product/medchat',
      name: 'ProductMedchat',
      meta: {
        scroll: true
      },
      component: resolve => require(['../views/MedChat_details.vue'], resolve)
    },
    {
      path: '/product/medevent',
      name: 'ProductMedevent',
      meta: {
        scroll: true
      },
      component: resolve => require(['../views/MedEvent_details.vue'], resolve)
    }
  ]
})
router.beforeEach((to, from, next) => {
  // 如果输入的是http 自动改为https
  let targetProtocol = 'https:'
  if (window.location.protocol != targetProtocol) {
    return (window.location.href =
      targetProtocol +
      window.location.href.substring(window.location.protocol.length))
  }
  // end

  var ua = window.navigator.userAgent.toLowerCase()
  if (
    !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    setTimeout(() => {
      var _hmt = _hmt || []
        ; (function () {
          //每次执行前，先移除上次插入的代码
          document.getElementById('baidu_tj') &&
            document.getElementById('baidu_tj').remove()
          var hm = document.createElement('script')
          hm.src = 'https://hm.baidu.com/hm.js?8a89475fa6fda1603b941283cad0f1dc'
          hm.id = 'baidu_tj'
          var s = document.getElementsByTagName('script')[0]
          s.parentNode.insertBefore(hm, s)
        })()
    }, 0)
    next()
  } else if (ua.indexOf('iphone') > 0 || ua.indexOf('android') > 0) {
    // 移动端
    let rURL = location.href
      .replace(location.origin, 'https://m.yuemia.com')
      .replace('/client', '/mobile')
    window.location.href = rURL
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js